<template>
  <div id="help">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        帮助留言列表
      </el-breadcrumb-item>
    </el-breadcrumb>
      <el-card class="box-card">
        <el-form ref="form" :model="searchForm" label-width="80px" :inline="true" size="small" class="admin_from">
        </el-form>
        <el-table size="small" :data="tableData" border style="width: 100%">
            <el-table-column type="index" label="用户ID" width="100">
                  <template slot-scope="scope">
                      {{ scope.row.userid }}
                  </template>
            </el-table-column>
            <el-table-column  label="邮件地址" width="300">
                  <template slot-scope="scope">
                    {{scope.row.email}}
                  </template>
            </el-table-column>
            <el-table-column  label="留言类容">
                <template slot-scope="scope">
                    {{scope.row.content}}
                </template>
            </el-table-column>
             <el-table-column  label="留言时间">
                <template slot-scope="scope">
                    {{scope.row.created_at}}
                </template>
            </el-table-column>
        </el-table>
        <div class="el-pagination">
            <el-pagination
                    background
                    @size-change="changeSize"
                    @current-change="changeCurrent"
                    :current-page="params.pagenum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="params.pagesize"
                    :total="params.totals"
                    :layout="this.$store.state.paginationLayout">
            </el-pagination>
        </div>
    </el-card>
  </div>
</template>  
<script>
export default {
  name: "help",
  data(){
      return {
        params:{
          page_num:1,
          page_size:10,
          totals:0,
        },
        dataForm:{
          email: '',
          content: '',
          userid:'',
        },
        tableData:[],
        exportList:[],
        fromTitle: '',
        visible:false,
        id:'',
      };
  },
  created(){
    this.getList();
  },
  methods:{
    getList(){
      let data = {
        page:this.params.page_num,
        page_size:this.params.page_size
      };
      this.$axios.post('admin/help/index',data).then(res => {
          console.log(res);
          this.params.totals = parseInt(res.data.count);
          this.tableData = res.data.list;
      });
    },
    changeSize(val){
      this.params.page_size = val;
      this.getList();
    },
    changeCurrent(val) {
      this.params.page_num = val;
      this.getList();
    },
  }
}
</script>
